interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "MYR";
};

const MYR: Currency = Object.freeze({
  "displayName": "Malaysian Ringgit",
  "numericCode": 458,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "before",
  "isoCode": "MYR",
  "symbol": "RM"
});

export { MYR };
